import { render } from "./TemplateTable.vue?vue&type=template&id=7641da49&scoped=true"
import script from "./TemplateTable.vue?vue&type=script&lang=js"
export * from "./TemplateTable.vue?vue&type=script&lang=js"

import "./TemplateTable.vue?vue&type=style&index=0&id=7641da49&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src141758530/src/mavent-project-vuejs-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7641da49"]])

export default __exports__